/* MAPI mini-cart FBT recommendation discount labels.
   Only decorates the drawer; leaves existing slider and add-to-cart JS alone. */
(() => {
  'use strict';
  const ROOT = '.fbt-root--drawer, [data-fbt-root][data-fbt-mode="drawer"]';
  const CARD = '.fbt-card';
  const cache = new Map();
  const watching = new WeakSet();
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);
  const prefix = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const productURL = card => {
    const href = card.querySelector('.fbt-card__image-link[href], .fbt-card__name[href]')?.href;
    if (!href) return null;
    const url = new URL(href, location.href);
    if (url.origin !== location.origin) return null;
    const match = url.pathname.match(/\/products\/([^/?#]+)/);
    return match ? `${prefix()}products/${match[1]}.js` : null;
  };
  async function product(url) {
    if (!cache.has(url)) cache.set(url, fetch(url, {credentials:'same-origin'}).then(r => {
      if (!r.ok) throw new Error(`Product JSON ${r.status}`);
      return r.json();
    }).catch(e => {cache.delete(url); throw e;}));
    return cache.get(url);
  }
  async function decorate(card) {
    if (card.dataset.mapiDrawerDiscountState) return;
    const url = productURL(card);
    const add = card.querySelector('[data-fbt-add], [data-mh-rec-add]');
    const variantId = add?.dataset.variantId || add?.dataset.mhRecAdd;
    const price = card.querySelector('.fbt-card__price');
    if (!url || !variantId || !price) return;
    card.dataset.mapiDrawerDiscountState = 'loading';
    try {
      const info = await product(url);
      if (!card.isConnected) return;
      const variant = info.variants?.find(v => String(v.id) === String(variantId));
      const current = Number(variant?.price);
      const compare = Number(variant?.compare_at_price);
      if (!variant || !Number.isFinite(current) || !Number.isFinite(compare) || compare <= current || current < 0) {
        card.dataset.mapiDrawerDiscountState = 'done'; return;
      }
      const row = document.createElement('span');
      row.className = 'mapi-drawer-rec-price-line';
      const old = document.createElement('s');
      old.className = 'mapi-drawer-rec-compare'; old.textContent = money(compare);
      const badge = document.createElement('span');
      badge.className = 'mapi-drawer-rec-off';
      badge.textContent = `${Math.round((compare-current)/compare*100)}% OFF`;
      price.before(row);
      row.append(old,price,badge);
      card.dataset.mapiDrawerDiscountState = 'done';
    } catch (error) {
      delete card.dataset.mapiDrawerDiscountState;
      console.warn('[MAPI drawer recommendation discount]',error);
    }
  }
  function init() {
    document.querySelectorAll(ROOT).forEach(root => {
      root.querySelectorAll(CARD).forEach(decorate);
      const track = root.querySelector('.fbt-grid, [data-fbt-track]');
      if (track && !watching.has(track)) {
        watching.add(track);
        new MutationObserver(() => track.querySelectorAll(CARD).forEach(decorate)).observe(track,{childList:true});
      }
    });
  }
  function start() {
    if (!document.getElementById('mapi-drawer-rec-price-style')) {
      const style = document.createElement('style'); style.id='mapi-drawer-rec-price-style';
      style.textContent=`
        :is(${ROOT}) .mapi-drawer-rec-price-line{display:flex;align-items:baseline;gap:4px 7px;flex-wrap:wrap;margin-top:6px}
        :is(${ROOT}) .mapi-drawer-rec-price-line .fbt-card__price{margin:0!important}
        :is(${ROOT}) .mapi-drawer-rec-compare{font-size:13px;color:#827b77;text-decoration:line-through;white-space:nowrap}
        :is(${ROOT}) .mapi-drawer-rec-off{color:#8b651c;font-size:11px;font-weight:700;letter-spacing:.06em;white-space:nowrap}
      `;
      document.head.append(style);
    }
    init();
    new MutationObserver(init).observe(document.body,{childList:true,subtree:true});
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',init);
})();
